// eslint-disable-next-line import/no-cycle
import * as loginApi from '@/api/login'
// eslint-disable-next-line import/no-cycle
import * as wechatApi from '@/api/wechatLogin'
import { getToken, removeToken, setTenantId, setToken } from '@/utils/auth'
import * as Sentry from '@sentry/vue'
import { authUtils } from 'blm-utils'

const user = {
  state: {
    token: getToken() || localStorage.TOKEN || null,
    userInfo: {},
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      localStorage.TOKEN = token
      state.token = token
    },
    SET_USER_INFO: (state, userInfo = {}) => {
      // localStorage.USERINFO = JSON.stringify(userInfo)
      state.userInfo = userInfo
      const tenantId = userInfo.tenantId || 1
      // 清理租牌相关 localStorage
      authUtils.clearHireSessionInfo()
      setTenantId(tenantId)
      Sentry.configureScope((scope) => {
        // 上报用户信息
        scope.setUser({ id: userInfo?.id })
      })
    },
  },
  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password.trim()
      const captcha = userInfo.captcha.trim()
      return new Promise((resolve, reject) => {
        loginApi.login(username, password, captcha).then((response) => {
          const { data } = response
          const userVO = data.userVO || {}
          commit('SET_USER_INFO', userVO)
          commit('SET_TOKEN', data.token)
          setToken({ token: data.token, expiration: data.expiration })
          resolve()
        }).catch((error) => {
          // 清理租牌相关 localStorage
          authUtils.clearHireSessionInfo()
          reject(error)
        })
      })
    },
    // 微信扫码登录：选择已绑定账号直接换取正式登录态（单段式，与 Login 一致）
    WeChatLogin({ commit }, { username, loginKey }) {
      return new Promise((resolve, reject) => {
        wechatApi.weChatSelectAndLogin({ username, loginKey }).then((response) => {
          const { data } = response
          // T8：出参字段名以联调为准，先 userVO/userInfo 兜底
          const userInfo = data.userVO || data.userInfo || {}
          commit('SET_USER_INFO', userInfo)
          commit('SET_TOKEN', data.token)
          setToken({ token: data.token, expiration: data.expiration })
          resolve(data)
        }).catch((error) => {
          authUtils.clearHireSessionInfo()
          reject(error)
        })
      })
    },
    // 微信扫码登录：短信验证绑定账号并直接换取正式登录态
    WeChatBindLogin({ commit }, { username, smsCode, loginKey }) {
      return new Promise((resolve, reject) => {
        wechatApi.weChatBindAndLogin({ username, smsCode, loginKey }).then((response) => {
          const { data } = response
          const userInfo = data.userVO || data.userInfo || {}
          commit('SET_USER_INFO', userInfo)
          commit('SET_TOKEN', data.token)
          setToken({ token: data.token, expiration: data.expiration })
          resolve(data)
        }).catch((error) => {
          authUtils.clearHireSessionInfo()
          reject(error)
        })
      })
    },
    SetUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        loginApi.getInfoByToken().then((response) => {
          const { data } = response
          const userInfo = data.userVO || {}
          userInfo.bindings = data.bindings || []
          commit('SET_USER_INFO', userInfo)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    RefreshToken() {
      return new Promise((resolve, reject) => {
        loginApi.refreshToken().then((response) => {
          const { data } = response
          setToken({ token: data.token, expiration: data.expiration })
          resolve()
        }).catch((error) => {
          this.$message.error(error.msg)
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      // 维保退出登陆
      loginApi.purchaseMallLogOut()
      return new Promise((resolve, reject) => {
        loginApi.logout().then(() => {
          commit('SET_USER_INFO', {})
          removeToken()
          localStorage.userInfo = ''
          resolve()
        }).catch((error) => {
          this.$message.error(error.msg)
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_USER_INFO', {})
        removeToken()
        localStorage.userInfo = ''
        resolve()
      })
    },
    // 解绑微信「通知」（/wechat/unbind），与解绑微信「登录」区分
    async UnbindWechat({ dispatch }) {
      await loginApi.unbindWechat()
      await dispatch('GetUserInfo')
    },
    // 解绑微信「登录」（本人：不传 userId，后端按 token 认身份）
    async UnbindWechatLogin({ dispatch }) {
      await wechatApi.unbindWechatLogin()
      await dispatch('GetUserInfo')
    },
  },
}

export default user
